// 입고 팝업
<template>
	<sf-modal-layout class="qms-xxl" :title="getMessage_('QWCC001554')" :show="show" :closeModal="close">
		<sf-data-table ref="popupTable" :columns="columns" :rows="whsnResultList" height="80vh" :stripe="false" :excel="isButton_(scrId, 'EX')">
			<template v-slot:actionsLeft>
				<!-- 입고 -->
				<sf-button v-if="isButton_(scrId, 'CU') && (isMmcAdmin || isMmcManager)" line icon="export" :onClick="whsnAction">
					{{ getMessage_('QWCC001554') }}
				</sf-button>
			</template>
			<template v-slot:customRows="slotProps">
				<template v-if="slotProps.column.property === 'mark'">
					<!-- 등록, 통지 상태일 때 -->
					<template
						v-if="
							(slotProps.row.calStCd === 'RGST' || slotProps.row.calStCd === 'INFM' || slotProps.row.calStCd === 'WHSN') &&
							slotProps.row.runStCd === 'NORM'
						"
					>
						<i class="icon-sf-circle-bottom successed"></i>
					</template>
					<template v-else>
						<i class="icon-sf-circle-close warned"></i>
					</template>
				</template>
				<!--  성적서 파일 -->
				<template v-if="slotProps.column.property === 'rslrFile'">
					<template v-if="!!slotProps.row.rslrFileId">
						<span @click="() => onDownloadFile(slotProps.row.rslrFileId)" style="cursor: pointer">
							<img src="/img/common/table/icon-sf-excel.svg" alt="excel icon" class="mr-1" />
						</span>
					</template>
				</template>
				<!-- 입고일자 -->
				<template v-if="slotProps.column.property === 'whsnDd'">
					<el-date-picker
						:value="slotProps.row.whsnDd?.replaceAll('-', '')"
						@input="val => changeInput(val, 'whsnDd', slotProps.row)"
						format="yyyy-MM-dd"
						value-format="yyyyMMdd"
						placeholder="yyyy-MM-dd"
					>
					</el-date-picker>
				</template>
				<!-- 입고시간 -->
				<template v-if="slotProps.column.property === 'whsnDt'">
					<el-time-picker
						:value="slotProps.row.whsnDt"
						@input="val => changeInput(val, 'whsnDt', slotProps.row)"
						value-format="HHmm"
						format="HH:mm"
						placeholder="HH:mm"
					>
					</el-time-picker>
				</template>
			</template>
		</sf-data-table>
		<!-- 등록, 통지된 장비만 입고처리 가능합니다. 가능하지 않은 장비는 선택이 제한 됩니다. -->
		<div class="mt-2">*** {{ getMessage_('QWCC001870') }} ***</div>
	</sf-modal-layout>
</template>

<script>
import * as Yup from 'yup';
import { serviceComputed, serviceMethods } from '@mmc/mmcm/MesInfm/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			show: false
		};
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open() {
			this.show = true;
		},
		close(success) {
			this.setState_({ key: 'whsnResultList', value: [] });
			this.show = false;
			!!success && this.refresh();
		},
		refresh() {
			this.$emit('Refresh');
		},
		changeInput(value, key, row) {
			try {
				if (row.calStCd !== 'RGST' && row.calStCd !== 'INFM' && row.calStCd !== 'WHSN' && slotProps.row.runStCd !== 'NORM') return;
				if (key === 'whsnDd') {
					if (value > this.$moment().format('YYYYMMDD')) {
						row[key] = this.$moment().format('YYYYMMDD');
						// 입고일은 미래 날짜가 될 수 없습니다
						throw new Error(this.$sf_formatString(this.getMessage_('QWCC001781'), [this.getMessage_('QWCC001582')]));
					}
				}
				row[key] = value;
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		whsnAction() {
			try {
				const filteredList = _.filter([...this.whsnResultList], row => !!row.whsn);
				if (!filteredList.length) {
					throw new Error(this.getMessage_('QWCC001556'));
				}
				for (const el of filteredList) {
					this.schemaSave.validateSync(el);
				}
				const filtered = filteredList.map(row => {
					return {
						mesEqipNo: row.mesEqipNo,
						calInstCd: row.calInstCd,
						eqipKndCd: row.eqipKndCd,
						whsnDt: row.whsnDd + row.whsnDt,
						rmk: row.rmk
					};
				});
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001623'), //입고 처리 하시겠습니까?
					buttons: [{ title: 'Ok', clickFn: () => this.sendwhsn(filtered) }]
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		async sendwhsn(row) {
			this.$sf_toggleLoading(true);
			try {
				const header = await this.saveWhsn_(row);
				if (header?.code == 0) {
					this.$sf_showMessage({
						icon: 'ok',
						message: this.getMessage_(header.messageCd),
						closeFn: () => this.close('success')
					});
				} else {
					throw new Error(data?.header?.messageCd);
				}
			} catch (error) {
				console.error(error);
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001533') }); // 오류가 발생했습니다.
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async onDownloadFile(fileId) {
			await this.fileDownload_({ fileId, fileSeq: 1 });
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		schemaSave() {
			return Yup.object().shape({
				calInstCd: Yup.string() //교정업체
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001579')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001579')])), //공정이상원인
				whsnDd: Yup.date() //입고일
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001582')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001582')])), //개선대책
				whsnDt: Yup.string() //입고시간
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001581')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001581')])) //대책일자
			});
		},
		columns() {
			return [
				{
					label: ' ',
					prop: 'mark',
					minWidth: '35px',
					custom: true,
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001554'), //입고 체크박스
					prop: 'whsn',
					minWidth: '55px',
					sortable: false,
					form: {
						type: 'checkBox',
						isDisabled: ({ row }) => {
							const emlStandard = row.calStCd == 'RGST' || row.calStCd == 'INFM' || row.calStCd == 'WHSN';
							return !emlStandard || row.runStCd !== 'NORM' ? true : false;
						}
					}
				},
				{
					label: this.getMessage_('QWCC001317'), //관리번호
					prop: 'mesEqipNo',
					minWidth: '90px'
				},
				{
					label: this.getMessage_('QWCC001314'), //장비명
					prop: 'mesEqipNm',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001325'), //교정방식
					prop: 'mdlNm',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC001579'), //교정업체
					prop: 'calInstCd',
					minWidth: '180px',
					form: {
						type: 'select',
						options: this.calInstCdList,
						isDisabled: ({ row }) => {
							const emlStandard = row.calStCd == 'RGST' || row.calStCd == 'INFM' || row.calStCd == 'WHSN';
							return !emlStandard || row.runStCd !== 'NORM' ? true : false;
						}
					}
				},
				{
					label: this.getMessage_('QWCC001348'), //성적서번호
					prop: 'rslrNo',
					minWidth: '160px'
				},
				{
					label: this.getMessage_('QWCC001628'), //성적서
					prop: 'rslrFile',
					minWidth: '60px',
					custom: true
				},
				{
					label: this.getMessage_('QWCC001780'), //입고일자
					prop: 'whsnDd',
					minWidth: '100px',
					custom: true
				},
				{
					label: this.getMessage_('QWCC001581'), //입고시간
					prop: 'whsnDt',
					minWidth: '70px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC001315'), //가동상태
					prop: 'runStCd',
					minWidth: '60px',
					form: {
						type: 'select',
						options: this.runStCdList,
						isDisabled: () => true
					}
				},
				{
					label: this.getMessage_('QWCC001316'), //교정상태
					prop: 'calStCd',
					minWidth: '60px',
					form: {
						type: 'select',
						options: this.calStCdList,
						isDisabled: () => true
					}
				},
				{
					label: this.getMessage_('QWCC000906'), //비고
					prop: 'rmk',
					minWidth: '250px',
					form: {
						type: 'input',
						maxByteSize: 200,
						isDisabled: ({ row }) => {
							const emlStandard = row.calStCd == 'RGST' || row.calStCd == 'INFM' || row.calStCd == 'WHSN';
							return !emlStandard || row.runStCd !== 'NORM' ? true : false;
						}
					}
				}
			];
		}
	}
};
</script>
<style lang="scss">
.el-checkbox__input .is-disabled {
	& > .el-table .el-checkbox__input .el-checkbox__inner {
		cursor: not-allowed !important;
	}
}
.el-table .el-checkbox__input .el-checkbox__inner {
	cursor: pointer;
}
</style>
